import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { AssignUserForm } from "Order/Components/Form/AssignUserForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";

const formResource = Resources.base.order.editForm;

type Props = {
	order: OrderDetailResponseDto;
};

export const OrderAssignUserWidget = ({ order }: Props) => {
	const { t } = useResource();
	return (
		<BaseCard title={t(formResource.user)}>
			<AssignUserForm order={order} />
		</BaseCard>
	);
};
